export default function PageHeader({ title, subtitle, actions, children }) {
  return (
    <div className="border-b border-slate-200 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-8 py-7 flex flex-wrap items-end gap-6 justify-between">
        <div className="min-w-0">
          {subtitle && (
            <div className="kbd-label mb-2" data-testid="page-eyebrow">
              {subtitle}
            </div>
          )}
          <h1
            className="font-display text-3xl sm:text-4xl font-bold text-slate-900 tracking-tight leading-tight"
            data-testid="page-title"
          >
            {title}
          </h1>
          {children && <div className="mt-2 text-slate-500 text-sm max-w-2xl">{children}</div>}
        </div>
        {actions && <div className="flex gap-2 items-center">{actions}</div>}
      </div>
    </div>
  );
}
